export const OPEN_MESSAGE = 'OPEN_MESSAGE';
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE';

export function openMessage(title, content) {
    return {
        type: OPEN_MESSAGE,
        payload: {title, content}
    }
}

export function closeMessage() {
    return {
        type: CLOSE_MESSAGE
    }
}



// WEBPACK FOOTER //
// ./src/common/components/messages/actions.js